import detectMobileBrowser from '../../utils/detectMobileBrowser'

export const removeWhiteSpaces = (text: string): string => text.replace(/^\s+|\s+$/gm, '')

export const generateWhatsappUrl = (whtasappNumber: string): string => {
  const formattedWhatsappNumber = whtasappNumber.replace(/\D/g, '')
  if (detectMobileBrowser()) {
    return `https://wa.me/${formattedWhatsappNumber}`
  }
  return `https://web.whatsapp.com/send?phone=${formattedWhatsappNumber}`
}

type TimeZoneTime = {
  time: string
  isWorkingHour: boolean
}

export const getCurrentTimeFromTimeZone = (timeZone?: string): TimeZoneTime | null => {
  if (!timeZone) return null

  const options = {
    timeZone,
    hour: 'numeric',
    minute: 'numeric',
  }
  const locationTime = {
    time: '',
    isWorkingHour: true,
  }
  try {
    // @ts-expect-error type issue
    const formatter = new Intl.DateTimeFormat([], options)

    const currentTime = formatter.format(new Date())
    const currentHour = currentTime.split(':')[0]

    locationTime.time = currentTime
    if (parseInt(currentHour, 10) < 19 && parseInt(currentHour, 10) > 7) {
      locationTime.isWorkingHour = true
    } else {
      locationTime.isWorkingHour = false
    }
  } catch (e) {
    // todo nothing
  }
  return locationTime
}
